import { pipe, map } from "rxjs"
import { Contact } from "src/app/core/models/common/contact.model"
import { FiscalId, FiscalIdKind } from "src/app/core/models/common/fiscal-id.model"
import { FiscalIdDto } from "src/app/infrastructure/lobby-proxy/DTOs/fiscal-id.dto"


export const mapFiscalIdDtoToFiscalId = pipe(
    map((source: FiscalIdDto) => fiscalIdDtoToFiscalId(source))
)

export function fiscalIdDtoToFiscalId(source: FiscalIdDto): FiscalId {
    return {
        id: source.id,
        description: source.description,
        value: source.value,
        isPreferred: source.isPreferred,
        kind: FiscalIdKind[source.kind as keyof typeof FiscalIdKind]
    } as FiscalId
}

export function fiscalIdsToDtoChangesContainerPartitaIva(created: FiscalId[], changed: FiscalId[], removed: FiscalId[]) {
    return {
        creates: created.map(f => {
            return {
                partitaIva: f.value,
                description: f.description,
                isPreferred: f.isPreferred
            }
        }),
        changes: changed.map(f => {
            return {
                id: f.id,
                description: f.description,
                isPreferred: f.isPreferred
            }
        }),
        removes: removed.map(f => f.id)
    }
}

export function fiscalIdsToDtoChangesContainerCodiceFiscale(created: FiscalId[], changed: FiscalId[], removed: FiscalId[]) {
    return {
        creates: created.map(f => {
            return {
                codiceFiscale: f.value,
                description: f.description,
                isPreferred: f.isPreferred
            }
        }),
        changes: changed.map(f => {
            return {
                id: f.id,
                description: f.description,
                isPreferred: f.isPreferred
            }
        }),
        removes: removed.map(f => f.id)
    }
}

